import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import { CANCELLATION_REASONS } from "../utils/cancellationReasons";

/** Asks why the clinic is cancelling before it does; `onConfirm` gets the reason id. */
const CancelReasonDialog = ({
  open,
  title = "Cancel appointment",
  description,
  hint = "Why are you cancelling? The patient is told.",
  keepLabel = "Keep appointment",
  confirmLabel = "Cancel appointment",
  submitting = false,
  onClose,
  onConfirm,
}) => {
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (open) setReason("");
  }, [open]);

  return (
    <Dialog open={open} onClose={() => !submitting && onClose()} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {description && <Typography mb={2}>{description}</Typography>}
        <Typography variant="body2" color="text.secondary" mb={1}>
          {hint}
        </Typography>
        <Stack spacing={1}>
          {CANCELLATION_REASONS.map((r) => (
            <Button
              key={r.id}
              data-testid={`cancel-reason-${r.id}`}
              variant={reason === r.id ? "contained" : "outlined"}
              onClick={() => setReason(r.id)}
              disabled={submitting}
              sx={{ justifyContent: "flex-start", textTransform: "none" }}
            >
              {r.label}
            </Button>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>
          {keepLabel}
        </Button>
        <Button
          variant="contained"
          color="error"
          data-testid="confirm-cancel"
          onClick={() => onConfirm(reason)}
          disabled={!reason || submitting}
        >
          {submitting ? "Cancelling…" : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelReasonDialog;
